module.exports = __webpack_public_path__ + "img/EM_Light.0c18bf74.svg";